import { authenticatedDeletewithPayload, authenticatedPatch } from '../../../../../api/request';

export default async function updateEducation(educationBody, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando su información de educación.');
    const url = '/doctor-profile/education';
    return await authenticatedPatch(url, onFail, educationBody);
}

export async function deleteEducation(idEducation, setErrorMessage) {
  const onFail = () => setErrorMessage('Ocurrió un error eliminando su educación.');
  const url = '/doctor-profile/education';
  const payload = { idEducation };

  return await authenticatedDeletewithPayload(url, onFail, payload);
}